import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import ArrowButton from "../ArrowButton";
import ActivityCard from "../ActivityCard";
import "./style.scss";

import "swiper/css";
import "swiper/css/navigation";
import AppVideoCard from "../AppVideoCard";

const DEFAULT_PRIZE_DESCRIPTION =
  "<span>10 % RABATT AUF AUSGEWÄHLTE ULTRA PODS</span>";

const ACTIVATION_PRIZE_DESCRIPTIONS = {
  ultrainsider_vuse_fragrance_2025: "<span>1 X FRAGRANCE KIT</span>",
  ultrainsider_poll_2025: "<span>100% RABATT AUF 1 PACKUNG PODS</span>",
  ultrainsider_match_the_power_2026: "<span>10 Punkte</span>",
  ultrainsider_find_the_flavour_2026: "<span>10 Punkte</span>",
  ultrainsider_quiz_33: "<span>Dein 15% auf Ultra Pods</span>",
  ultrainsider_quiz_41: "<span>20 Punkte</span>",
};

const getPrizeDescription = (activation) => {
  if (activation.ident === "poll-placeholder") {
    return activation.content?.description ?? "";
  }

  if (activation.prizeDescription) {
    return activation.prizeDescription;
  }

  return (
    ACTIVATION_PRIZE_DESCRIPTIONS[activation.ident] ?? DEFAULT_PRIZE_DESCRIPTION
  );
};

export default function PrizeSlider({ awardsToRender = [] }) {
  return (
    <div className="ultra-insider-award-slider">
      <div className="slider">
        <div className="cta-group">
          <div className="swiper-button-prev award">
            <ArrowButton reverse />
          </div>
          <div className="swiper-button-next award">
            <ArrowButton />
          </div>
        </div>
        <Swiper
          className="premiumSwiper-activities"
          modules={[Navigation]}
          spaceBetween={28}
          slidesPerView={1.1}
          navigation={{
            nextEl: ".swiper-button-next.award",
            prevEl: ".swiper-button-prev.award",
          }}
          breakpoints={{
            720: {
              slidesPerView: "auto",
              spaceBetween: 20,
            },
          }}
        >
          {awardsToRender.map((activation, index) => {
            if (activation.ident === "app-video-placeholder") {
              return (
                <SwiperSlide key={index}>
                  <AppVideoCard
                    mobileImg={activation?.thumbnail?.file?.url}
                    desktopImg={activation?.hero_image?.file?.url}
                    imgDesc={activation?.hero_image?.metadata?.imgDesc}
                    copy={activation?.content?.title}
                    points={activation.payout}
                    brands={activation.brands}
                    completed={activation.completed}
                    ident={activation.ident}
                    type={activation.type}
                    highlighted={activation.highlighted}
                    disabled={activation.disabled}
                    date={activation?.date}
                    description={activation.description || ""}
                  />
                </SwiperSlide>
              );
            }
            return (
              <SwiperSlide key={index}>
                <ActivityCard
                  mobileImg={activation?.thumbnail?.file?.url}
                  desktopImg={activation?.hero_image?.file?.url}
                  imgDesc={activation?.hero_image?.metadata?.imgDesc}
                  copy={activation?.content?.title}
                  points={activation.payout}
                  brands={activation.brands}
                  completed={activation.completed}
                  ident={activation.ident}
                  type={activation.type}
                  highlighted={activation.highlighted}
                  disabled={activation.disabled}
                  date={activation?.date}
                  withButton={activation.withButton}
                  className={activation.noHover ? "no-hover" : ""}
                  buttonCopy={activation.buttonCopy}
                  onClick={
                    activation.nonClickable
                      ? (e) => e.preventDefault()
                      : undefined
                  }
                  description={`PRÄMIE: ${getPrizeDescription(activation)}`}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
}
